/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Configuration/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Autodraft from './Autodraft/index'
import CustomPlanRulesets from './CustomPlanRulesets/index'
import DefaultPaymentPlans from './DefaultPaymentPlans/index'
import DownPayment from './DownPayment/index'
import FeatureAccess from './FeatureAccess/index'
import Frequencies from './Frequencies/index'
import MaxDiscount from './MaxDiscount/index'
import PaymentMethods from './PaymentMethods/index'
import React from 'react'
import Steps from './Steps/index'
import SubMenuTab from 'DesignSystem/SubMenuTab/index'
import SupportOnly from 'DesignSystem/SupportOnly/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Configuration({
  children,
  viewPath = "/App/Account/Content/Settings/AdminContent/SettingsContent/TreatmentCaseCloser/Configuration"
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'FeatureAccess'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="Configuration.Vertical"
  data-view-path={viewPath}
 style={{'--mt-1-Z1PT9vj': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Configuration.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-2-Z1PT9vj': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal}`}
>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Feature Access"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './FeatureAccess'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './FeatureAccess'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Flow Steps"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './Steps'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './Steps'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Payment Frequencies"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './Frequencies'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './Frequencies'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Autodraft"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './Autodraft'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './Autodraft'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Down Payment"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './DownPayment'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './DownPayment'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Custom Plan Ruleset"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './CustomPlanRulesets'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './CustomPlanRulesets'))}
/>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Default Payment Plans"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './DefaultPaymentPlans'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './DefaultPaymentPlans'))}
/>
<SupportOnly
  viewPath={`${viewPath}/SupportOnly`}
>
{childProps => (
<SubMenuTab
{...childProps}
  viewPath={`${viewPath}/SubMenuTab`}
 text="Payment Methods"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './PaymentMethods'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './PaymentMethods'))}
/>
)}
</SupportOnly>
<SubMenuTab
  viewPath={`${viewPath}/SubMenuTab`}
 text="Max Discount"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, './MaxDiscount'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, './MaxDiscount'))}
/>
</div>
<fromFlow.When is={flowValue === 'FeatureAccess'}>
<FeatureAccess
  viewPath={`${viewPath}/FeatureAccess`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Steps'}>
<Steps
  viewPath={`${viewPath}/Steps`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Frequencies'}>
<Frequencies
  viewPath={`${viewPath}/Frequencies`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Autodraft'}>
<Autodraft
  viewPath={`${viewPath}/Autodraft`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DownPayment'}>
<DownPayment
  viewPath={`${viewPath}/DownPayment`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'CustomPlanRulesets'}>
<CustomPlanRulesets
  viewPath={`${viewPath}/CustomPlanRulesets`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'DefaultPaymentPlans'}>
<DefaultPaymentPlans
  viewPath={`${viewPath}/DefaultPaymentPlans`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'MaxDiscount'}>
<MaxDiscount
  viewPath={`${viewPath}/MaxDiscount`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'PaymentMethods'}>
<PaymentMethods
  viewPath={`${viewPath}/PaymentMethods`}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}